import { ChakraBox, Text } from '@equip.health/ui';
import { DateTime } from 'luxon';

import { extractIANATimezone } from '~/components/maud/providerAssignment/utils';
import { getTimezoneAbbreviation } from '~/lib/util/timezone.util';

export const toValidTimeZone = (raw?: string): string | undefined => {
  const zone = extractIANATimezone(raw);
  return zone && DateTime.local().setZone(zone).isValid ? zone : undefined;
};

// Grouped by abbreviation and by offset at both window ends: New_York and
// Indiana/Indianapolis share an "EST" pill, while Phoenix and Denver split when
// the window crosses a DST change. The group keeps its first zone.
export const buildTimeZoneOptions = (
  people: { name: string; timeZone?: string }[],
  window: { start: Date; end: Date } = { start: new Date(), end: new Date() },
): { title: string; zone: string }[] => {
  const groups = new Map<
    string,
    { abbreviation: string; names: string[]; zone: string }
  >();
  people.forEach(({ name, timeZone }) => {
    if (!timeZone) {
      return;
    }
    const abbreviation = getTimezoneAbbreviation(
      timeZone,
      window.start.toISOString(),
    );
    const offsetAt = (date: Date) =>
      DateTime.fromJSDate(date, { zone: timeZone }).offset;
    const key = `${abbreviation}|${offsetAt(window.start)}|${offsetAt(window.end)}`;
    const group = groups.get(key);
    if (group) {
      group.names.push(name);
    } else {
      groups.set(key, { abbreviation, names: [name], zone: timeZone });
    }
  });
  return [...groups.values()].map(({ abbreviation, names, zone }) => ({
    title: `${names.join(', ')} · ${abbreviation}`,
    zone,
  }));
};

export const renderModalTitle = ({
  currentStep,
  isEditing = false,
}: {
  currentStep: 'confirmation' | 'slotSelection';
  isEditing?: boolean;
}) => {
  if (currentStep === 'confirmation') {
    return (
      <ChakraBox
        display="flex"
        flexDirection="column"
        gap="24px"
        marginBottom="6px"
      >
        <Text variant="h4">Confirm appointment</Text>
      </ChakraBox>
    );
  }
  return isEditing
    ? 'Select new admissions consultation'
    : 'Add admissions consultation';
};
